/**
 * Helper classes to properly parse JSON data from PHP to TS obbjects
 */
import {Property} from "./data/Property";
import {ViewConfig} from "./App3D";
import * as THREE from "three";
let hash = require('object-hash');

export module Data{
	export class Uniform{
		type: string = null;
		value: any = null;
		constructor(data){
			Object.assign(this, data);
		}
	}

	/**
	 * Set of shaders for material
	 */
	export class Shaders{
		vertex: string = null;
		fragment: string = null;
		vertexSized: string = null;
		vertexCorrected: string = null;

		/**
		 * @param {object} data original shader data (initialized from PHP)
		 * @param {number} flags additional shader versions to load (ShaderEnv)
		 */
		constructor(data:object, flags:number = 0){
			Object.assign(this, data);
			if (flags & ShaderEnv.FlagSizing){
				this.vertexSized = this.vertex + '&flags='+(flags & ~ShaderEnv.FlagUVCorrection).toString(16);
				if (flags & ShaderEnv.FlagUVCorrection)
					this.vertexCorrected = this.vertex + '&flags='+flags.toString(16);
			}
		}

		get data(): {[shader:string]: string}{
			let data = {
				vertex: this.vertex,
				fragment: this.fragment,
			};
			if (this.vertexSized)
				data['vertexSized'] = this.vertexSized;
			if (this.vertexCorrected)
				data['vertexCorrected'] = this.vertexCorrected;
			return data;
		}
	}

	/**
	 * Set of resources for single material
	 */
	export class Material{
		protected _prototypeID: string;
		shaders: Shaders;
		textures: { [textureID: string]: string } = {};
		texturesC: { [textureID: string]: string[] } = {};
		uniforms: { [uniformID: string]: Uniform } = {};

		/**
		 * Creates new Material from JSON data
		 * @param data Material data
		 * @param name Material name (for debugging)
		 * @param flags Shader flags (for sizing)
		 */
		constructor(data,
				public name: string = 'unknown',
				flags:number = 0){

			this.shaders = new Shaders(data.shaders, flags);
			if (data.hasOwnProperty('textures'))
				Object.assign(this.textures, data.textures);
			if (data.hasOwnProperty('texturesC'))
				Object.assign(this.texturesC, data.texturesC);
			if (data.hasOwnProperty('uniforms'))
				for (let uID in data.uniforms)
					if (data.uniforms.hasOwnProperty(uID))
						this.uniforms[uID] = new Uniform(data.uniforms[uID]);
			this._prototypeID = hash.MD5(data);
		}

		get prototypeID(){
			return this._prototypeID;
		}

		get data(){
			return {
				shaders: this.shaders.data,
				textures: this.textures,
				texturesC: this.texturesC,
				uniforms: this.uniforms
			}
		}
	}

	/**
	 * @hidden
	 * from MenuProductItem PHP Class
	 */
	export class Product{
		price: any;
		code: string;
		model: string;
		attributes: any;
		textures: any;
		properties: any;
		shared_parts: string[];
		navigator: any;

		/**
		 * @hidden
		 * Creates new Product from JSON data
		 * @param data
		 */
		constructor(data){
			Object.assign(this, data);
		}
	}

	export class CatalogItem{
		code: string;
		label: string;
		price: number;
		conditions: { [property: string]: string } = {};
		product: string = null;

		/**
		 * Creates new ProductData from JSON data
		 * @param data
		 */
		constructor(data){
			Object.assign(this, data);
		}
	}

	/**
	 * @see app/autoload/Product.php Product::getJSData()
	 */
	export class ProductData{
		active_product: string;
		// load_models: { [modelID: string]: string } = {};
		model_index:  { [modelID: string]: string } = {};
		code_pattern: string;
		products: any;
		catalog: { [itemID: string]: CatalogItem } = {};
		materials: any;
		properties: { [propID:string]: Property } = {};
		view_config: ViewConfig = new ViewConfig;
		per_mesh_textures: any;
		materials_default: any;
		meta: { [mVar: string]: string } = {};

		/**
		 * Creates new ProductData from JSON data
		 * @param data
		 */
		constructor(data){
			// create callback from position templates
			Object.assign(this, data);

			for (let prop in data.properties)
				if (data.properties.hasOwnProperty(prop))
					this.properties[prop] = new Property(prop, data.properties[prop]);
		}
	}

	export class UniformSet{
		public size: THREE.Uniform;
		public uvScale: THREE.Uniform;

		constructor(){
			this.size = new THREE.Uniform(new THREE.Vector3(0,0,0));
			this.uvScale = new THREE.Uniform(new THREE.Vector2(1,1));
		}
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/Data.ts